export default "__VITE_ASSET__BFlOQXL3__"